import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, map } from 'rxjs/operators';

import {
  BulkReservationsResponse,
  FromCsvReservationsRequest,
  FromCsvReservationsResponse,
  ImportedReservation,
} from '@shared/party/models';
import { of } from 'rxjs';
import { ApiClientService } from '@tablesready/api-client';
import { AlertsService, IAlertTypes } from '@tablesready/frontend-alerts-bar';
import { NavigationService } from '@tablesready/common-ui';

@Injectable()
export class ImportService {
  private readonly baseUrl = '/v.1/reservations';

  constructor(
    private readonly http: ApiClientService,
    private readonly alertService: AlertsService,
    private readonly navService: NavigationService,
  ) {
  }

  uploadFile(data: FromCsvReservationsRequest, file) {
    const _data = toFormData(data);
    _data.append('file', file);

    return this.http.post<FromCsvReservationsResponse>(`${this.baseUrl}/fromCSV`, _data)
      .pipe(
        map(({success, error, data}) => {
          if (success) {
            return data;
          }
          throw new Error(`${error}`);
        }),
      );
  }

  saveBulk(reservations: ImportedReservation[], sendConfirmation: boolean) {
    return this.http
      .post<BulkReservationsResponse>(`${this.baseUrl}/bulk`, {reservations, sendConfirmation})
      .pipe(
        map(result => {
          if (result.success) {
            this.alertService.add({
              type: IAlertTypes.success,
              heading: 'Success:',
              body: 'saved imported reservations.',
            });
            return this.navService.refresh('/reservations');
          }
          throw result.error;
        }),
        catchError(error => {
          this.alertService.add({
            time: Date.now(),
            type: IAlertTypes.danger,
            heading: 'Error:',
            body: error.error?.error || error,
          });

          return of();
        }),
      );
  }
}

function toFormData(data) {
  const formData = new FormData();
  for (const [key, value] of Object.entries<any>(data)) {
    formData.append(key, value);
  }

  return formData;
}
